export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_API_URL || '',
};

export const AUTH_ROUTES = {
  LOGIN: '/login',
  CALLBACK: '/callback',
  HOME: '/home',
} as const;

/**
 * Scopes de Auth0 solicitados para la aplicación
 * Centralizado para mantener consistencia en toda la aplicación
 */
export const AUTH_SCOPES = "openid profile email read:alert create:alert send:alert read:user create:user update:user read:roles read:resource_servers all:silent send:tepic"; 